import Icon, { size } from './components/Icon';

export default Icon;
export { size };
export { default as Skeleton } from './components/Skeleton';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/icon/dist/esm/index.js
// module id = 174
// module chunks = 0